(function () {
  var nodes = document.querySelectorAll('[data-flash-countdown]');
  if (!nodes.length) return;

  var timers = [];
  var tick = null;

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  Array.prototype.forEach.call(nodes, function (el) {
    var end = parseInt(el.getAttribute('data-end'), 10);
    if (isNaN(end)) return;

    var days = el.querySelector('[data-cd-days]');
    var hours = el.querySelector('[data-cd-hours]');
    var mins = el.querySelector('[data-cd-mins]');
    var secs = el.querySelector('[data-cd-secs]');
    if (!days || !hours || !mins || !secs) return;

    timers.push({
      el: el,
      end: end,
      days: days,
      hours: hours,
      mins: mins,
      secs: secs,
      done: false
    });
  });

  if (!timers.length) return;

  function render() {
    var now = Math.floor(Date.now() / 1000);
    var active = 0;

    for (var i = 0; i < timers.length; i++) {
      var t = timers[i];
      if (t.done) continue;

      var left = t.end - now;

      if (left <= 0) {
        t.el.setAttribute('hidden', '');
        t.done = true;
        continue;
      }

      active++;
      t.el.removeAttribute('hidden');
      t.days.textContent = Math.floor(left / 86400);
      t.hours.textContent = pad(Math.floor((left % 86400) / 3600));
      t.mins.textContent = pad(Math.floor((left % 3600) / 60));
      t.secs.textContent = pad(left % 60);
    }

    if (active === 0 && tick) {
      clearInterval(tick);
      tick = null;
    }
  }

  render();
  tick = setInterval(render, 1000);

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) render();
  });
})();